import { useEffect, useState } from 'react';
import { Col, Button, Card, Form, Input, Typography, message, Skeleton } from 'antd';

import useLoading from 'hooks/use-loading';
import useDecodeToken from 'hooks/use-decode-token';
import UserService from 'api-services/user-service';

function UserProfile() {
  const { Title } = Typography;
  const { setLoading } = useLoading();
  const { userId } = useDecodeToken();

  const [userInfo, setUserInfo] = useState(null);
  const [skeleton, setSkeleton] = useState(true);

  useEffect(() => { //handling on change of user id  
    const getUserInfo = async () => { //getting user info from id
      setSkeleton(true);
      if (userId) {
        const userInfo = await UserService.getUser(userId);
        setUserInfo(userInfo);
      }
      setSkeleton(false);
    };

    getUserInfo();
  }, [userId]);

  /* User information update */
  const updateUserInformation = async(values)=>{
    try { 
      setLoading(true);
      if (values.password === '') delete values.password;

      const data = await UserService.updateUser(userId, values); //updating user at backend
      
      if (data) { //checking if successful
        message.success('Profile updated successfully');
      }
    } catch (err) { //negative response validation
      let errMessage = 'Something went wrong. Please try again.'; 
      if (err.response && err.response.data) { //getting error message from API
        if (err.response.data.message) {
          errMessage = err.response.data.message;
        } else if (err.response.data.errors) {
          if (err.response.data.errors.email) errMessage = err.response.data.errors.email;
          else if (err.response.data.errors.password) errMessage = err.response.data.errors.password;
        }
      }
      message.error(errMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Col
      xs={{ span: 24, offset: 0 }}
      sm={{ span: 18, offset: 0 }}
      md={{ span: 14, offset: 0 }}
      lg={{ span: 10, offset: 0 }}>
      <Title level={4}>
        <strong>Update Profile</strong>
      </Title>

      {skeleton && <Card><Skeleton active/></Card>}

      {!skeleton && <Card>
        {userInfo && (
          <Form
            id='update-user-info'
            name='basic'
            onFinish={updateUserInformation}
            labelCol={{
              span: 6,
            }}
            wrapperCol={{
              span: 18,
            }}
            labelAlign='left'
            labelWrap
            initialValues={{
              remember: true,
            }}
            autoComplete='off'>
            <Form.Item
              label='First Name'
              name='firstName'
              initialValue={userInfo.firstName}
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: 'Please input your First Name!',
                },
              ]}>
              <Input />
            </Form.Item>
            <Form.Item
              label='Last Name'
              name='lastName'
              initialValue={userInfo.lastName}
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: 'Please input valid Last Name!',
                },
              ]}>
              <Input />
            </Form.Item>
            <Form.Item
              label='Email Address'
              name='email'
              initialValue={userInfo.email}
              rules={[
                {
                  type: 'email',
                  required: true,
                  message: 'Please input your Email Address!',
                },
              ]}>
              <Input />
            </Form.Item>

            <Form.Item label='Password' name='password' initialValue=''>
              <Input type='password' placeholder='Password' />
            </Form.Item>
            <p className='mailto-label'>
          Please&nbsp;
              <a href='mailto:team@chatbuddypro.com' title='team@chatbuddypro.com'>
            contact us
              </a>
          &nbsp; if you want to get your account deleted.
            </p>
            <Form.Item
              wrapperCol={{
                span: 24,
              }}              >
              <Button type='primary' htmlType='submit' style={{float:'right'}}>
                Update Profile
              </Button>
            </Form.Item>
          </Form>
        )}

    
      </Card>}
    </Col>
  );
}

export default UserProfile;
